<div id="app-wrapper" class="app mat-typography" [dir]="uiService.directionObject().direction" [class.inventory-counter-page]="url && url.includes('/invcounter')" [ngClass]="{'app-dark': options.dark, 'boxed': options.boxed, 'collapsed-sidebar': options.collapsed, 'compact-sidebar': options.compact, 'side-panel-opened': sidePanelOpened, 'side-panel-closed': !sidePanelOpened }">
  <!-- <ngx-loading-bar color="#009688"></ngx-loading-bar> -->

  <app-header (toggleSidenav)="sidemenu.toggle()" (toggleNotificationSidenav)="notifications.toggle()"></app-header>

  <mat-sidenav-container class="app-inner" id="app-inner-wrapper">
    <!--class="sidebar-panel" class="TITAN-ui-menuitem-text"-->
    <mat-sidenav #sidemenu class="sidebar-panel"  id="sidebar-panel"
                 [mode]="isOver() ? 'over' : 'side'"
                 [opened]="!isOver()"
                 (opened)="handleSidebarToggle(true)"
                 (closed)="handleSidebarToggle(false)"
                 (mouseover)="menuMouseOver()"
                 (mouseout)="menuMouseOut()"
                 >
      <app-sidebar (click)="updatePS()"></app-sidebar>
    </mat-sidenav>

    <mat-sidenav #notifications position="end" class="chat-panel" mode="over" opened="false">
      <app-notification></app-notification>
    </mat-sidenav>
    <div >
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-container>

  <!-- Demo Purposes Only -->
  <!-- <app-options (messageEvent)="receiveOptions($event)"></app-options> -->
  <!-- /Demo Purposes Only -->
</div>
